const attr = (key, value) =>
    (key &&
        value !== undefined &&
        value !== null && { [`data-feature-${key}`]: value }) ||
    {};
export default function featureAttr({ name, position, instance }) {
    return {
        ...attr("name", name),
        ...attr("position", position),
        ...attr("instance", instance),
    };
}
